import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useItemStore = (storeId: string) => {
    return defineStore(storeId, () => {
        const isUpdated = ref(false);
        const items = ref<any[]>([]);
        const isRecentPendingOrders = ref<boolean>(false);

        const getItemCount = computed(() => items.value.length);

        const setUpdated = (value: boolean): void => {
            isUpdated.value = value;
        };

        const setItems = <T>(newItems: T[] | undefined): void => {
            items.value = newItems || [];
        };

        const setRecentPendingOrders = (status: boolean): boolean => (isRecentPendingOrders.value = status);

        const isMaxReached = (take: number): boolean => getItemCount.value <= take;

        const setItem = <T>(item: T): void => {
            items.value.push(item);
            setUpdated(true);
        };

        const prependItem = <T>(item: T): void => {
            items.value.unshift(item);
            setUpdated(true);
        };

        const deleteItem = (itemId: string): void => {
            const index = items.value.findIndex(item => item.id === itemId);
            if (index > -1) items.value.splice(index, 1);
        };

        return {
            isUpdated,
            items,
            getItemCount,
            isRecentPendingOrders,
            setUpdated,
            setRecentPendingOrders,
            isMaxReached,
            setItems,
            setItem,
            prependItem,
            deleteItem
        };
    });
};

export const useBaseStore = () => {
    const isUpdated = ref(false);
    const items = ref<any[]>([]);
    const isRecentPendingOrders = ref<boolean>(false);

    const getItemCount = computed(() => items.value.length);

    const setUpdated = (value: boolean): void => {
        isUpdated.value = value;
    };

    const setItems = <T>(newItems: T[] | undefined): void => {
        items.value = newItems || [];
    };

    const setRecentPendingOrders = (status: boolean): boolean => (isRecentPendingOrders.value = status);

    const isMaxReached = (take: number): boolean => getItemCount.value <= take;

    const setItem = <T>(item: T): void => {
        items.value.push(item);
        setUpdated(true);
    };

    const prependItem = <T>(item: T): void => {
        items.value.unshift(item);
        setUpdated(true);
    };

    const deleteItem = (itemId: string): void => {
        const index = items.value.findIndex(item => item.id === itemId);
        if (index > -1) items.value.splice(index, 1);
    };

    return {
        isUpdated,
        items,
        getItemCount,
        isRecentPendingOrders,
        setUpdated,
        setRecentPendingOrders,
        isMaxReached,
        setItems,
        setItem,
        prependItem,
        deleteItem
    };
};
